import { Box, styled, Typography } from "@mui/material";
import { Field } from "formik";

export const Label = styled("label")({
  display: "flex",
  fontSize: "14px",
  fontWeight: 500,
  margin: "0px",
  flexDirection: "row",
  alignItems: "center",
  color: "#212B33"
});

export const FormLabelText = styled(Typography)({
  color: "#1D1F2B",
  fontSize: "12px",
  fontWeight: "400"
});

export const LabelRowBox = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "15px"
});

export const ObjectSelectionHintText = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: "12px",
  fontWeight: "400",
  marginTop: "4px !important"
}));
